import { render } from "preact";
import { App } from "./App";

export function mountUI(root: HTMLElement): void {
  render(<App />, root);
}
